export const routes = {
  home: "/",
  reachOut: "/reach-out",
  salesSimplified: "/sales-simplified",
  campaigns: "/campaigns",
  experience: "/experience",
  testimonials: "/testimonials",
  leadership: "/leadership",
  salesmrkt: "https://salesmrkt.com/",
  privacyPolicy: "/privacy-policy",
  marketplace: "/reach-out",
  // marketplace: "https://marketplace.gotryone.com/account/login?source=salesbox",
  finTech: "/services/fin-tech",
  foodBeverage: "/services/food-beverage",
  healthcare: "/services/healthcare",
  hr: "/services/hr",
  marketing: "/services/marketing",
  professionalServices: "/services/professional-services",
  techSaas: "/services/tech-saas",
  wdec: "/wdec", 
  terms: "/terms"
};
